<template>
  <div ref="playerEl" style="width:100%; height:100%; position:absolute; top:0; left:0;" />
</template>

<script setup lang="ts">

const props = defineProps({
  videoId: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:view-count'])

const playerEl = ref(null);
let player:any = null
let timer:any = null
let hasCounted = false;
let wasEnded = false;

// YouTube API 로드
function loadYouTubeAPI() {
  return new Promise<void>((resolve) => {
    if (window.YT?.Player) {
      resolve()
      return
    }

    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    document.head.appendChild(tag)

    window.onYouTubeIframeAPIReady = () => resolve()
  })
}

// 컴포넌트 마운트 시 YouTube API 로드 및 플레이어 초기화
onMounted(async () => {
  await loadYouTubeAPI();

  if(props.videoId) {
    player = new YT.Player(playerEl.value, {
      videoId: props.videoId,
      playerVars:{
        controls: 1,
        rel: 0,
        origin: window.location.origin,
      },
      events: {
        onStateChange,
      },
    });
  }
})

// 플레이어 상태 변경 시 처리
function onStateChange(event) {
  switch (event.data) {
    case YT.PlayerState.PLAYING: { // 재생 시작
      // 마지막 재생이 끝나고 1초 이내에 다시 재생되면 조회수 카운트 초기화
      if (wasEnded && player.getCurrentTime() < 1) {
        wasEnded = false;
        hasCounted = false;
      }
      startPolling();
      break
    }
    case YT.PlayerState.ENDED: { // 재생 종료
      wasEnded = true
      stopPolling();
      break
    }
    case YT.PlayerState.PAUSED: { // 일시정지
      stopPolling()
      break
    }
    case YT.PlayerState.BUFFERING: // 버퍼링
    default:
      break
  }
}

// 폴링 시작
function startPolling() {
  if (timer) return

  timer = setInterval(() => {
    const current = player.getCurrentTime() // 현재 재생 시간
    const duration = player.getDuration() // 총 재생 시간

    if (!hasCounted && duration > 0 && current / duration >= 0.5) {
      console.log('[50% 이상 시청]')
      hasCounted = true;
      emit('update:view-count');
    }
  }, 500)
}

// 폴링 중지
function stopPolling() {
  clearInterval(timer)
  timer = null
}

// 컴포넌트 언마운트 시 폴링 중지
onBeforeUnmount(() => {
  stopPolling();
  player?.destroy();
})
</script>